import { usePage } from "@inertiajs/react";
import { useEffect, useRef } from "react";

import { captureProductPageview, isProductAnalyticsEnabled } from "@/lib/product-analytics";

export function PosthogPageViewTracker() {
  const { url } = usePage();
  const lastCapturedKey = useRef<string | null>(null);

  useEffect(() => {
    if (!isProductAnalyticsEnabled()) return;

    const absoluteUrl = new URL(url, window.location.origin).toString();
    const pageTitle = document.title;
    const captureKey = `${absoluteUrl}|${pageTitle}`;

    if (lastCapturedKey.current === captureKey) return;

    captureProductPageview(absoluteUrl, pageTitle);
    lastCapturedKey.current = captureKey;
  }, [url]);

  return null;
}
